export const Badge = ({ children, className }) => {
  return <div className={`px-2 py-0.5 rounded-full ${className} text-xs text-white shadow flex justify-center items-center`}>
    <div className='relative -top-[1.25px]'>
      {children}
    </div>
  </div>;
};